import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Wrench, Inbox, ChevronRight } from 'lucide-react';
import { Card, Avatar } from '../../ui-v2';
import { Badge } from '../../ui-v2.5';
// 3/11 (B2) · las etiquetas de estado, de etiquetasEstado.js (antes, una copia aquí con ui-v2).
import { ESTADO_CITA, MODALIDAD, etiquetaDe } from '../compartidos/etiquetasEstado';

export default function PanelDia({ fecha, citas }) {
  const navigate = useNavigate();

  const totalDelDia = citas.length;
  const dateObj = fecha ? new Date(fecha + 'T00:00:00') : null;

  return (
    <Card className="overflow-hidden p-0 sticky top-32">
      <div className="px-5 py-4 border-b border-slate-100">
        {dateObj ? (
          <>
            <h2 className="text-base font-medium text-slate-900">
              {formatDia(dateObj)}
            </h2>
            <p className="text-xs text-slate-500 mt-0.5">
              {totalDelDia === 0
                ? 'Sin citas'
                : `${totalDelDia} ${totalDelDia === 1 ? 'cita' : 'citas'}`}
            </p>
          </>
        ) : (
          <p className="text-sm text-slate-500">Selecciona un día del calendario.</p>
        )}
      </div>

      {totalDelDia === 0 ? (
        <div className="px-5 py-12 text-center">
          <Inbox className="w-7 h-7 mx-auto mb-2 text-slate-300" />
          <p className="text-xs text-slate-400">
            No hay citas programadas este día.
          </p>
        </div>
      ) : (
        <ul className="divide-y divide-slate-100 max-h-[600px] overflow-y-auto">
          {citas.map((c) => {
            const meta = etiquetaDe(ESTADO_CITA, c.estado);
            return (
              <li
                key={c.id}
                onClick={() => navigate(`/citas-tecnicas/campanas/${c.campana_id}/resumen`)}
                className="px-5 py-3 hover:bg-slate-50/60 cursor-pointer"
              >
                <div className="flex items-start gap-3">
                  <div className="shrink-0 text-right w-14">
                    {/* Registrada sin cita (24/10): no tiene hora; se dice cómo se hizo. */}
                    <div className="text-sm font-medium text-slate-900 tabular-nums">
                      {c.hora_inicio || etiquetaDe(MODALIDAD, c.modalidad).label}
                    </div>
                    <div className="text-[10px] text-slate-400 tabular-nums">
                      {c.hora_inicio ? c.hora_fin : 'sin cita'}
                    </div>
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <Avatar name={c.usuario.nombre_completo} size="sm" />
                      <div className="text-sm text-slate-900 truncate">
                        {c.usuario.nombre_completo}
                      </div>
                    </div>
                    <div className="text-xs text-slate-500 truncate ml-8">
                      {c.campana_titulo}
                    </div>
                    <div className="flex items-center gap-1.5 mt-1 ml-8 text-[11px] text-slate-500">
                      <Wrench className="w-3 h-3 text-slate-400" />
                      <span className="truncate">{c.tecnico.nombre_completo}</span>
                    </div>
                  </div>

                  <div className="shrink-0 flex flex-col items-end gap-1">
                    <Badge tone={meta.tone}>{meta.label}</Badge>
                    <ChevronRight className="w-3.5 h-3.5 text-slate-300" />
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
}

function formatDia(d) {
  return d.toLocaleDateString('es-ES', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  });
}
